import mitt from 'mitt'

const bus = mitt()

export default bus;

/**
 * 示例
 *
 * // 父组件
 * bus.emit('函数名', 需要传的值)
 *
 * //子组件
 * bus.on('函数名'，（接收到的值）=>{
 * 	逻辑操作
 * })
 *
 */